import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';

/**
 * DELETE /api/eraf/users/{id} — 사용자 소프트 삭제
 * 성공 시 목록 쿼리 무효화
 */
export function useDeleteUser() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => userApi.delete(id),
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
      qc.removeQueries({ queryKey: ['user-management', 'detail', id] });
    },
  });
}
